'use client';
import React, { useEffect, useLayoutEffect } from 'react';

import loadBackgroudImages from '../../common/loadBackgroudImages';
function Header() {
  useEffect(() => {
    loadBackgroudImages();
  }, []);
  return (
    <header
      className="main-header bg-img valign"
      style={{
        backgroundImage: "url('/assets/imgs/background/bg5.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
      data-overlay-dark="7"
    >
      <div className="container ontop">
        <div className="row">
          <div className="col-lg-11">
            <div className="caption">
              <h1>Where <span className="main-color">your</span> ideas </h1>
              <div className="d-flex align-items-end">
                <div>
                  <h1 className="nowrap">
                     taking shapes.
                  </h1>
                </div>
                <div>
                  <div className="text ml-30">
                    <p>
                      We don't hide behind thousands of projects.{' '}<span className="text-light fw-600">We focus on yours.</span>{' '}
                      We build modern digital worlds from scratch – without unnecessary baggage and with maximum commitment.                      
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-80">
          <div className="col-lg-6 order-md-2">
            <div className="icon-img">
              <img src="/assets/imgs/icon-img/arrow-down-big.png" alt="" />
            </div>
          </div>
          <div className="col-lg-6 d-flex justify-content-end order-md-1">
            <div className="info">
              <h2 className="mb-10">A personal approach</h2>
              <h6>
                {/* priorita číslo <span className="main-color">jedna!</span> */}
                is our number one <span className="main-color">priority!</span>
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div className='transitiondiv'></div>
    </header>
  );
}

export default Header;
